<template>
  <div class="page">
    <div class="plate-one">
      <div class="plate-one-logo">
        <img src="@/assets/logo.png" alt="">
      </div>
    </div>
    <div class="plate-two">
      <div class="plate-two-title">
        <img :src="title1" alt="">
      </div>
    </div>
    <div class="plate-three">
      <div class="plate-three-video">
        <player-video :pv="pv" :liveInfo="liveInfo"></player-video>
      </div>
    </div>
    <div class="plate-four">
      <div class="plate-four-img plate-four-img_one">
        <img src="@/assets/p3.png" alt="">
      </div>
      <div class="plate-four-img plate-four-img_two">
        <img src="@/assets/p4.png" alt="">
      </div>
      <div class="plate-four-right">
        <div class="plate-four-right-canvas">
          <good-up ref="good"/>
        </div>
        <div class="plate-four-right-good" @click="triggerFloatStar">
          <img src="@/assets/good.png" alt="">
        </div>
        <div class="plate-four-right-num">{{$handleUnit(goodNum)}}</div>
      </div>
    </div>
    <div class="plate-five">
      <router-link to="/" replace>
        <img src="@/assets/go-home.png" alt="">
      </router-link>
    </div>
  </div>
</template>

<script>
import PlayerVideo from '@/components/video/index-b'
import GoodUp from '@/components/good-up/index'
import { getLiveInfo, addGoodUp, getPv, addPv } from '@/api/api'
import { mapGetters } from 'vuex'
export default {
  components: { PlayerVideo, GoodUp },
  data() {
    return {
      type: null,
      liveInfo: {},
      goodNum: 0,
      second: 0,
      pv: 0,
      title1: require('@/assets/title7.png')
    }
  },
  async created() {
    this.$wxShare(
      '2022年徐汇区“全国科普日”活动',
      '“新徐汇 新科普”云上嘉年华',
      'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_2a12fa0ad8df461b887daafe09631388.png'
    )
    this.getLiveInfo(1429)
    await addPv({
      headimgurl: '吴彦祖',
      nickName: '吴彦祖',
      realName: '吴彦祖'
    }, 1429)
    this.getGoodNum()
    if (this.liveState === 2) {
      setInterval(() => {
        this.getGoodNum()
      }, 3000);
    }
  },
  mounted() {
    this.type = this.$route.query.type
  },
  computed: {
    ...mapGetters(['liveState'])
  },
  methods: {
    // 点击触发飘心
    async triggerFloatStar() {
      if (this.liveState === 2) {
        this.$refs.good.floatStar()
        this.second++
        this.goodNum++
        if (this.second >= 2) {
          await addGoodUp({ liveId: 1429 })
          this.second = 0
        }
      } else {
        this.$toast('直播未开始')
      }
    },
    // 获取点赞数
    getGoodNum() {
      getPv('', 1429).then(res => {
        var data = res.data
        this.pv = data.pv
        if (this.goodNum < data.praise) {
          this.goodNum = data.praise
        }
      })
    },
    // 获取直播间信息
    getLiveInfo(id) {
      const data = { openId: 'openId' }
      getLiveInfo(data, id).then(res => {
        this.liveInfo = res.data
        console.log(this.liveInfo)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  $all-width: 94%;
  .page {
    width: 100%;
    height: 100%;
    background: url(~@/assets/bg3.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    img {
      width: 100%;
    }
  }
  .plate-three {
    &-video {
      width: 96%;
      height: 2.01rem;
      margin: auto;
      border: 1px solid #fff;
    }
  }
  .plate-four {
    // flex-shrink: 1;
    flex-grow: 1;
    width: 96%;
    margin: auto;
    margin-top: .2rem;
    position: relative;
    display: flex;
    &-img {
      z-index: 1;
      position: absolute;
      &_one {
        width: 1.85rem;
        top: 38%;
      }
      &_two {
        width: 1.5rem;
        right: 25%;
        top: 0;
      }
    }
    &-right {
      height: 100%;
      display: flex;
      margin-left: auto;
      flex-direction: column;
      width: .8rem;
      &-canvas {
        flex-shrink: 1;
        flex-grow: 1;
      }
      &-good {
        width: .3rem;
        margin: 0 auto;
      }
      &-num {
        color: #fff;
        font-size: .13rem;
        text-align: center;
        margin-top: .05rem;
      }
    }
  }
  .plate-five {
    width: 25%;
    padding-bottom: .2rem;
    margin: 0 auto;
    animation-name: btn;
    animation-duration: 1.5s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
  }
  @keyframes btn {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: .4;
      transform: scale(.9);
    }
  }
</style>
